import { getFirstAttributeValue } from "@scayle/storefront-nuxt";
export const isProductSuggestion = (suggestion) => {
  return suggestion.type === "product";
};
export const isCategorySuggestion = (suggestion) => {
  return suggestion.type === "category";
};
export const isNavigationItemSuggestion = (suggestion) => {
  return suggestion.type === "navigationItem";
};
export const getSuggestionName = (suggestion) => {
  if (!suggestion.type) {
    return;
  }
  if (isCategorySuggestion(suggestion)) {
    return suggestion.categorySuggestion.category.name;
  }
  if (isProductSuggestion(suggestion)) {
    const { attributes } = suggestion.productSuggestion.product;
    return getFirstAttributeValue(attributes, "name")?.label ?? "";
  }
  if (isNavigationItemSuggestion(suggestion)) {
    return suggestion.navigationItemSuggestion.navigationItem.name;
  }
};
export const getSearchFilterLabels = (filters = []) => {
  return filters.reduce((labels, filter) => {
    switch (filter.type) {
      case "attribute":
        return [
          ...labels,
          ...filter.attributeFilter.values.map(({ label }) => label)
        ];
      case "boolean":
        return [...labels, filter.booleanFilter.label];
    }
    return labels;
  }, []);
};
